Apt.fn.make('filters', {
	/**
	 * Initialize module
	 *
	 * @returns {Object}
	 */
	init() {
		const scope = this;
		const priv = scope.$private;

		priv.setup();

		scope.refresh($.context('location'));

		$.app.filters.$resume(true);

		priv.bindToggle();

		LS.util.idle([
			priv.bindButtons,
			priv.bindCheck,
			priv.bindMore,
			priv.bindForm,
			() => {
				const $form = $$('filters');

				if (! $form.length) {
					return;
				}

				priv.ranges = Apt.fn['filters.ranges']().init({
					app: 'filters',
					context: $form,
					submit: () => {
						scope.submit();
					}
				});

				LS.util.restrict('[inputmode]', () => {
					priv.merge();
				}, $form);
			}
		], priv);

		return scope;
	},

	/**
	 * Merge filters into app
	 *
	 * @param {Boolean|Object} [loc]
	 */
	refresh(loc) {
		const scope = this;
		const priv = scope.$private;
		const locator = LS.header.locator;

		priv.merge(LS.filters.get());

		if (locator && loc !== false) {
			locator.set(loc);
		}

		scope.current = priv.serialize();
	},

	/**
	 * Destroy module
	 *
	 * @private
	 */
	_destruct() {
		LS.util.reset('filters', this.$private, [
			'ranges'
		], true);
	}
}, {
	/**
	 * @private
	 */
	_construct() {
		const scope = this;

		scope.bounds = {
			price: {
				min: [0, 25000, 50000, 75000, 100000, 250000, 500000],
				max: [25000, 50000, 75000, 100000, 250000, 500000, 1000000]
			},
			size: {
				min: [0, 2, 5, 10, 20, 50, 100],
				max: [2, 5, 10, 20, 50, 100, 250]
			}
		};

		scope.criteria = [
			'tag',
			'type'
		];

		scope.more = [
			'bathrooms',
			'bedrooms',
			'buffer',
			'dom',
			'format',
			'hoa',
			'images',
			'keywords',
			'mls',
			'pending',
			'ppa',
			'space',
			'structure',
			'year'
		];

		scope.model = {
			input: {},
			formats: LS.formats,
			prices: {
				bound: 'min',
				options: scope.bounds.price.min
			},
			reset: 0,
			sizes: {
				bound: 'min',
				options: scope.bounds.size.min
			},
			tags: LS.criteria,
			types: LS.types
		};
	},

	/**
	 * Serialize filters form
	 *
	 * @returns {Object}
	 */
	serialize() {
		const data = $$('filters').serialize(true);
		const locator = LS.header.locator;
		const sort = LS.filters.get('sort');

		if (locator && locator.val()) {
			const value = locator.val();

			if (value.type === 'address') {
				data.center = value.slug.split('+');
				data.zoom = 14.4;
			} else {
				data.location = value.slug;
			}
		}

		if (sort) {
			data.sort = sort;
		}

		return data;
	},

	/**
	 * Create the filter app
	 */
	setup() {
		const scope = this;

		$.app.make('filters', {
			view: 'filters.form',
			target: '$filters',
			model: $.copy(scope.model),
			init: false
		});

		scope.headings = $$('filterHeading').map(el => Number(el.dataset.id));
	},

	/**
	 * Hide filters
	 *
	 * @param {Boolean} [submit=false]
	 */
	hideFilters(submit) {
		const scope = this;

		scope.visibleFilter = false;

		$.app.filters.$drop('active');

		$.events.reset('activeFilter');

		LS.util.uncrop();

		document.body.classList.remove('-is-filtered');

		if (submit) {
			scope.$public.submit();
		}
	},

	/**
	 * Merge filters into model
	 *
	 * @param {Object} [data]
	 * @param {Object} [append]
	 */
	merge(data, append) {
		const model = $.app.filters.$get();

		data = data || LS.filters.extract(
			$$('filters').serialize()
		);

		if (append) {
			data = Object.assign(data, append);
		}

		model.input = data;
		model.reset = LS.filters.count(model.input);

		this.count(model);

		$.app.filters.$set(model);
	}
});